module.exports = __webpack_public_path__ + "static/media/control-verde.f9a1f2ef.svg";